import alt from 'components/Dispatcher';
import {List} from 'immutable';
import AdminAccountIntegrationActions from 'actions/admin/AdminAccountIntegrationActions';
import {Store} from '@store/@types/alt';
import IntegrationDataInfo from 'records/IntegrationDataInfo';

interface AdminAccountIntegrationStoreState {
  integrations: List<IntegrationDataInfo>;
}

class AdminAccountIntegrationStore extends Store<AdminAccountIntegrationStoreState> {
  constructor() {
    super();
    this.state = {
      integrations: List(),
    };
    this.bindActions(AdminAccountIntegrationActions);
  }

  /**
   * Parse the list of integrations returned from the backend
   */
  onFetchAdminAccountIntegrationsSuccess(integrations: IntegrationDataInfo[]) {
    this.setState({integrations: List(integrations)});
  }
}

export default alt.createStore(AdminAccountIntegrationStore);
